import { useMutation, useQueryClient } from "@tanstack/react-query";
import { createUserWithEmailAndPassword, sendEmailVerification } from "firebase/auth";
import { notification } from "antd";
import { auth, db } from "../../firebase/firebase";
import { addDoc, collection, updateDoc, Timestamp } from "firebase/firestore";
import { EnumeratorRegisterPayload } from "./dto";
import { storage } from "../../utils/storage";
import dayjs from "dayjs";
import { RoleTypes } from "enum/role-type-enum";

export const signUpWithEmail = async (data: EnumeratorRegisterPayload): Promise<{ user: any }> => {
    const { emailOrPhone, password } = data;

    try {

        const userCredential = await createUserWithEmailAndPassword(auth, emailOrPhone, password);
        const user = userCredential.user;

        storage.setUserInStorage(user);

        let firstName = "";
        let lastName = "";
        if (user.displayName) {

            firstName = user.displayName.split(" ")[0];
            lastName = user.displayName.split(" ")[1];
        }

        const userInfosCollection = collection(db, "user_infos");

        const userInfoDocRef = await addDoc(userInfosCollection, {
            "uid": user.uid,
            "createdAt": Timestamp.fromDate(dayjs().toDate()),
            "email": emailOrPhone,
            "firstName": firstName,
            "lastName": lastName,
            "role": RoleTypes.ENUMERATOR,
            "isVerified": false,
        });
        await updateDoc(userInfoDocRef, { id: userInfoDocRef.id });
        await sendEmailVerification(user);

        return { user };
    } catch (error:any) {
        if (error?.code === "auth/email-already-in-use") {
            return Promise.reject(new Error("Registration failed: email already in use"));
        } else {
            return Promise.reject(new Error("Registration failed"));
        }
    }
};

export const useSignUpWithEmail = () => {
    const queryClient = useQueryClient();

    return useMutation({
        onSuccess: async (_, __, ___) => {
            await queryClient.invalidateQueries({ queryKey: ["ENUMERATOR"] });
            notification.success({
                message: "Registration Successful",
                description: "A verification email has been sent. Please verify your email before logging in.",
            });
        },
        mutationFn: signUpWithEmail,
    });
};